/// <amd-module name="SuiteCommerce.Testimonials.TestimonialsCCT.Configuration"/>
define("SuiteCommerce.Testimonials.TestimonialsCCT.Configuration", ["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var LinkOptions;
    (function (LinkOptions) {
        LinkOptions["title"] = "title";
        LinkOptions["subtitle"] = "subtitle";
        LinkOptions["image"] = "image";
        LinkOptions["entireArea"] = "entire-area";
    })(LinkOptions = exports.LinkOptions || (exports.LinkOptions = {}));
    var LINK_OPTION_MAP = {
        1: '',
        2: 'title',
        3: 'subtitle',
        4: 'image',
        5: 'entire-area'
    };
    var COLOR_OPTION_MAP = {
        1: '',
        2: 'testimonial-color-text-dark',
        3: 'testimonial-color-text-light'
    };
    var CCTConfiguration = /** @class */ (function () {
        function CCTConfiguration() {
        }
        CCTConfiguration.getLinkByOption = function (option) {
            return LINK_OPTION_MAP[option] || '';
        };
        CCTConfiguration.getColorByOption = function (option) {
            return COLOR_OPTION_MAP[option] || '';
        };
        return CCTConfiguration;
    }());
    exports.CCTConfiguration = CCTConfiguration;
});
